import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/empresas/tipos-de-categorias-de-comercios-informales/';

/**
 * GET Peritos
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeCategoriasDeComercios = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * GET Tipo de Anuncio
 * @returns {Promise<object>}
 */
export const getTipoDeCategoriaDeComercio = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Tipo de Anuncio
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeCategoriaDeComercio = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * PATCH Tipo de Anuncio
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeCategoriaDeComercio = async (id, _values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, _values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE TipoZonaExclusiva
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDeCategoriaDeComercio = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
